import { TAGS_FETCH_ALL } from "../actions/typeKey"


const defatultState = {
    tags : []
}

function tagsReducer(state = defatultState,action){
    switch (action.type){
        case TAGS_FETCH_ALL : 
            return {
                tags : action.payload
            }
        default : 
            return state
    }
}

export default tagsReducer